module.exports = __webpack_public_path__ + "img/answer_report_success.731a10b6.svg";